var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "singleDisbursementModal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("send_pagements.payment_details"),
            "close-on-click-modal": false,
            width: "739px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("send_pagements.single_payment_details")) +
                " "
            ),
          ]),
          _c("div", { staticClass: "section-tip" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    "tips.select_receiving_channel_and_fill_payments_details"
                  )
                ) +
                " "
            ),
          ]),
          _c(
            "div",
            { staticClass: "form-container" },
            [
              _c(
                "el-form",
                {
                  ref: "singleDisbursementForm",
                  attrs: {
                    model: _vm.singleDisbursementForm,
                    "status-icon": "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "merchantAccount.recipient_channel"
                                ),
                                prop: "code",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "select-item",
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.singleDisbursementForm.full_name,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.singleDisbursementForm,
                                        "full_name",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "singleDisbursementForm.full_name",
                                  },
                                },
                                _vm._l(_vm.bankList, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name_with_full_bank,
                                      value: item.bank_code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11, offset: 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "send_pagements.recipient_account_number"
                                ),
                                prop: "account_no",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "search-frame",
                                attrs: {
                                  autocomplete: "off",
                                  maxlength: "30",
                                  clearable: "",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.singleDisbursementForm.account_no,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.singleDisbursementForm,
                                      "account_no",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression:
                                    "singleDisbursementForm.account_no",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("merchantAccount.recipient_name"),
                                prop: "account_name",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "search-frame",
                                attrs: {
                                  autocomplete: "off",
                                  maxlength: "60",
                                  clearable: "",
                                  disabled: "",
                                },
                                on: {
                                  blur: function ($event) {
                                    _vm.singleDisbursementForm.account_name =
                                      $event.target.value.trim()
                                  },
                                },
                                model: {
                                  value:
                                    _vm.singleDisbursementForm.account_name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.singleDisbursementForm,
                                      "account_name",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "singleDisbursementForm.account_name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11, offset: 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("components.amount"),
                                prop: "amount",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "custom-input-number",
                                attrs: {
                                  controls: false,
                                  autocomplete: "off",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.singleDisbursementForm.amount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.singleDisbursementForm,
                                      "amount",
                                      $$v
                                    )
                                  },
                                  expression: "singleDisbursementForm.amount",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("customerService.email_address"),
                                prop: "email",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "search-frame",
                                attrs: {
                                  autocomplete: "off",
                                  clearable: "",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.singleDisbursementForm.email,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.singleDisbursementForm,
                                      "email",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "singleDisbursementForm.email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("data.remark") } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  autocomplete: "off",
                                  maxlength: "255",
                                  disabled: "",
                                },
                                on: {
                                  blur: function ($event) {
                                    _vm.singleDisbursementForm.remark =
                                      $event.target.value.trim()
                                  },
                                },
                                model: {
                                  value: _vm.singleDisbursementForm.remark,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.singleDisbursementForm,
                                      "remark",
                                      $$v
                                    )
                                  },
                                  expression: "singleDisbursementForm.remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }